import { Tag } from '../ui/tag';

export default function HierarchyTag({ children, colorScheme }: { children: React.ReactNode; colorScheme?: string }) {
    return (
        <Tag fontWeight="bold" colorScheme={colorScheme} textTransform="uppercase">
            {children}
        </Tag>
    );
}
